import React, { useContext, useEffect } from "react";
import "./App.css";
import "@aws-amplify/ui-react/styles.css";
import { AppProviders } from "./providers/AppProviders";
import SlugQueryManager from "./appcomponents/SlugQueryManager";
import AdminApp from "./appcomponents/AdminApp";
import ModeratorApp from "./appcomponents/ModeratorApp";
import OperatorApp from "./appcomponents/OperatorApp";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import SimpleBottomNavigation from "./SimpleBottomNavigation";
import { CognitoUserContext } from "./contexts/cognitoUserContext";
import { getUserRole } from "./services/user/cognitoService";
import { Hub } from "aws-amplify";
import ErrorBoundary from "./components/ErrorBoundary";

function AppContent() {
  const { cognitoUser, setCognitoUser } = useContext(CognitoUserContext);
  const role = getUserRole(cognitoUser);

  useEffect(() => {
    return Hub.listen('auth', ({ payload: { event } }) => {
      if (event === 'signOut') setCognitoUser(null);
    });
  }, [setCognitoUser]);

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/" element={
          <>
            {role === 'ADMIN' && (
              <ErrorBoundary fallbackMessage="The admin interface encountered an error.">
                <div className="App">
                  <AdminApp />
                </div>
              </ErrorBoundary>
            )}
            {role === 'MODERATOR' && (
              <ErrorBoundary fallbackMessage="The moderator interface encountered an error.">
                <div className="App">
                  <ModeratorApp />
                </div>
              </ErrorBoundary>
            )}
            {role === 'OPERATOR' && (
              <ErrorBoundary fallbackMessage="The operator interface encountered an error.">
                <div className="App">
                  <OperatorApp />
                </div>
              </ErrorBoundary>
            )}
            {(role === 'STANDARD' || role === 'GUEST') && (
              <ErrorBoundary fallbackMessage="The search interface encountered an error.">
                <>
                  <div className="App">
                    <SlugQueryManager />
                  </div>
                  <SimpleBottomNavigation />
                </>
              </ErrorBoundary>
            )}
          </>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default function WrapperApp() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}
